import type { FaireProductEntity } from "../../entity_types/product";

export const p_fwappbqpqq: FaireProductEntity = {
  token: "p_fwappbqpqq",
  type: "product",
  name: "sports ball baseball softball football trucker hat chains",
  brandToken: "b_a9hebqmabw",
  brandName: "ABLNco",
  imageUrl:
    "https://cdn.faire.com/fastly/8e623662d74760a15379e55f7b81f620c065fa17c4141c52219618f25b16c0f3.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.78,
  description:
    "chains are made with two clasps ends\n\nsize: to fit standard trucker hat sizing ",
  tags: [],
  msrpDollars: 23.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:33.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
